import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CmsConfig, provideConfig, provideDefaultConfig} from '@spartacus/core';
import { UigParagraphComponent } from './uig-paragraph.component';
import { UigPipesModule } from 'src/app/pipes/uig-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    UigPipesModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CMSParagraphComponent: {
          component: UigParagraphComponent,
        },
        CMSTabParagraphComponent: {
          component: UigParagraphComponent,
        },
      },
    }),
  ],
  declarations: [UigParagraphComponent],
  exports: [UigParagraphComponent]
})
export class UigParagraphModule { }
